import { Button, ButtonProps } from "@chakra-ui/react";

const PrimaryButton = ({
  children,
  ...props
}: ButtonProps & { href?: string }) => (
  <Button as={props.as} variant="primary" {...props}>
    {children}
  </Button>
);

export default PrimaryButton;
